import { useCollection } from '@cloudscape-design/collection-hooks';
import { Box, Header, SpaceBetween, Button, Table, Link } from '@cloudscape-design/components';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApiNoBody } from '../../common/api';
import { AuthRole } from '../../common/types';
import { getHeaderCounterText } from '../../common/full-header';

export function RolesTable() {
  const [roles, setRoles] = useState<AuthRole[]>([]);
  const navigate = useNavigate();

  const [fetchApi, error, fetchLoading] = useApiNoBody<AuthRole[]>('/auth/roles', 'GET', setRoles);

  const loading = fetchLoading;

  const fetchRoles = async () => {
    await fetchApi();
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const { items, collectionProps } = useCollection(roles, {});

  return (
    <Table
      {...collectionProps}
      columnDefinitions={[
        {
          id: 'name',
          header: 'Name',
          cell: (item) => (
            <Link
              href={`/manage/auth/roles/${item.name}`}
              variant="secondary"
              onFollow={(e) => {
                e.preventDefault();
                navigate(`/manage/auth/roles/${item.name}`);
              }}
            >
              {item.name}
            </Link>
          ),
        },
      ]}
      empty={
        <Box color="inherit" textAlign="center">
          <b>No roles</b>
          <Box color="inherit" padding={{ bottom: 's' }} variant="p">
            No roles to display.
          </Box>
        </Box>
      }
      header={
        <Header
          actions={
            <SpaceBetween direction="horizontal" size="xs">
              <Button disabled={loading} iconName="refresh" onClick={fetchRoles} />
            </SpaceBetween>
          }
          counter={getHeaderCounterText(roles, collectionProps.selectedItems)}
        >
          Roles
        </Header>
      }
      items={items}
      loading={loading}
      loadingText="Loading roles"
      trackBy="name"
    />
  );
}
